import { initFirebase } from '../firebase/init';

const { auth, database, firebase, firestore, functions } = initFirebase();

export { firebase, auth, database, firestore, functions };
